<script lang="ts">
	import { reveal } from '$lib/actions/reveal';
	import Counter from '$lib/components/ui/Counter.svelte';
	import SectionHeading from '$lib/components/ui/SectionHeading.svelte';
	import { metrics } from '$lib/data/metrics';
</script>

<section class="mx-auto mt-20 max-w-[1216px] px-4 sm:mt-32 lg:px-0">
	<div class="reveal" use:reveal>
		<SectionHeading eyebrow="Engineered for scale" title="Benchmarks that matter" />
	</div>
	<div
		class="stagger-children grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/[0.06] bg-white/[0.06] lg:grid-cols-4"
		use:reveal
	>
		{#each metrics as m}
			<div class="relative bg-[#07080D] p-6 sm:p-8 lg:p-10">
				<Counter
					target={m.value}
					suffix={m.suffix}
					decimals={m.decimals ?? 0}
					class="metric-number font-display text-4xl font-medium tracking-tight sm:text-5xl lg:text-6xl"
				/>
				<p class="mt-3 font-display text-sm text-white/65">{m.label}</p>
				<p class="mt-1 font-display text-xs text-white/35">{m.sublabel}</p>
			</div>
		{/each}
	</div>
</section>
